// libs
import React from 'react';
// styles
import styles from './InfoFooter.module.scss';
function InfoFooter({ renderInfo, renderContent, footerClassName, }) {
    return (React.createElement("div", { className: styles.container },
        renderContent(),
        React.createElement("div", { className: styles.info }, renderInfo())));
}
export default InfoFooter;
